import React from "react";
import { Text } from "react-native-paper";
import {
  StyleSheet,
  View,
  Image,
  ImageBackground,
  Dimensions,
} from "react-native";
import { whiteColor, blackColor } from "../../common/colors";
import blue from "./blueChart.png";
import yellow from "./yellowChart.png";
import green from "./greenChart.png";
import red from "./redChart.png";
import radarBackground_pl from "./chart_empty-pl.png";
import radarBackground_en from "./chart_empty-en.png";

const sizeOfChart =
  Dimensions.get("window").width > 600 ? 600 : Dimensions.get("window").width;


const getRadarBackground = ((language) => {
  switch (language) {
    case 'en_GB':
      return radarBackground_en;
    default:
      return radarBackground_pl;
  }
});

const PolarChart = (props) => {
  const denominator =
    (props.result.R + props.result.B + props.result.G + props.result.Y) / 2;
  const yPercentage = props.result.Y / denominator;
  const rPercentage = props.result.R / denominator;
  const gPercentage = props.result.G / denominator;
  const bPercentage = props.result.B / denominator;

  const half = (sizeOfChart - sizeOfChart * 0.175) / 2;

  const yPX = yPercentage * half;
  const rPX = rPercentage * half;
  const gPX = gPercentage * half;
  const bPX = bPercentage * half;
  const radarBackground = getRadarBackground(props.language);
  
  return (
    <View style={styles.wrapper}>
      <View style={styles.content}>
        <View style={styles.labelText2}>
          <Text style={styles.design}></Text>
        </View>
        <View style={styles.wrapper}>
          <View style={styles.labelTextTop}>
            <Text style={styles.design}></Text>
          </View>
          <ImageBackground
            source={radarBackground}
            resizeMode="cover"
            style={styles.container}
          >
            <View style={styles.item} opacity={0.5}>
              <Image
                source={blue}
                style={[styles.blue, { width: bPX, height: bPX }]}
              />
            </View>
            <View style={styles.item}>
              <Image
                source={red}
                style={[styles.red, { width: rPX, height: rPX }]}
              />
            </View>
            <View style={styles.item}>
              <Image
                source={green}
                style={[styles.green, { width: gPX, height: gPX }]}
              />
            </View>
            <View style={styles.item}>
              <Image
                source={yellow}
                style={[styles.yellow, { width: yPX, height: yPX }]}
              />
            </View>
          </ImageBackground>
          <View style={styles.labelTextBottom}>
            <Text style={styles.design}></Text>
          </View>
        </View>
        <View style={styles.labelText3}>
          <Text style={styles.labelTextRight}></Text>
        </View>
      </View>
    </View>
  );
};

export default PolarChart;

const styles = StyleSheet.create({
  content: {
    width: 350,
  },
  wrapper: {
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
  },
  labelTextTop: {
    marginBottom: -12,
    textTransform: "uppercase",
  },
  labelTextBottom: {
    marginTop: -10,
    textTransform: "uppercase",
  },
  labelText2: {
    marginBottom: -145,
    paddingTop: 145,
    textTransform: "uppercase",
    color: blackColor,
    fontSize: 8,
  },
  design: {
    color: blackColor,
    fontSize: 8,
    textTransform: "uppercase",
  },
  labelText3: {
    marginTop: -145,
    paddingBottom: 145,
    textTransform: "uppercase",
    color: blackColor,
    fontSize: 8,
  },
  labelTextRight: {
    textAlign: "right",
    color: blackColor,
    fontSize: 8,
    textTransform: "uppercase",
  },
  container: {
    width: sizeOfChart,
    height: sizeOfChart,
    flexDirection: "row",
    flexWrap: "wrap",
    alignContent: "center",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
    position: "relative",
  },
  item: {
    width: "50%",
    height: "50%",
    position: "relative",
  },
  red: {
    position: "absolute",
    left: -2,
    bottom: -1.5,
    transform: [{ rotate: "0deg" }],
    opacity: 0.4,
  },
  green: {
    position: "absolute",
    right: 2.5,
    top: 1.5,
    transform: [{ rotate: "0deg" }],
    opacity: 0.4,
  },
  blue: {
    position: "absolute",
    right: 2.5,
    bottom: -1.5,
    transform: [{ rotate: "0deg" }],
    opacity: 0.4,
  },
  yellow: {
    position: "absolute",
    left: -2,
    top: 1.5,
    transform: [{ rotate: "0deg" }],
    opacity: 0.4,
  },
});
